import React from "react";
import { Card, Typography } from "@mui/material";
import { getMostradorLabel } from "../../../../config/constants";
import EstadoEntradaBadge from "./EstadoEntradaBadge";
import DetallesTurno from "./DetallesTurno";

const sxTarjeta = { p: 2, borderRadius: 2, boxShadow: "0 2px 8px rgba(0,0,0,0.1)", textAlign: "center" };
const sxNumero = { fontSize: "2.25rem", fontWeight: 700, lineHeight: 1.2, color: "#212529" };
const sxMostrador = { fontWeight: 500, color: "#6c757d", mt: 0.5 };
const sxBadge = { mt: 1.5 };

/**
 * Tarjeta compacta de un turno (últimos llamados y en espera). Con
 * mostrarDetalles=false no pinta los pedidos asociados
 */
const TurnoCard = ({ turno, mostrarMostrador = false, mostrarDetalles = true }) => (
    <Card sx={sxTarjeta}>
        <Typography component="div" sx={sxNumero}>{turno.numero}</Typography>
        {mostrarMostrador && turno.mostrador && (
            <Typography sx={sxMostrador}>{getMostradorLabel(turno.mostrador)}</Typography>
        )}
        <Typography component="div" sx={sxBadge}>
            <EstadoEntradaBadge estado={turno.estado} />
        </Typography>
        {mostrarDetalles && <DetallesTurno detalles={turno.detalles} />}
    </Card>
);

export default React.memo(TurnoCard);
